import { SvgIcon, SxProps } from "@mui/material";
import FallbackMaleAvatarSvg from "jsx:../../../Images/Icons/Custom/fallbackAvatarMale.svg";

export function AvatarMaleFallbackIcon(props: SxProps) {
    return (
        <SvgIcon component={FallbackMaleAvatarSvg} inheritViewBox sx={props} />
    );
}
